import { BALANCE_SLIDE_STEP } from '../../data-types/enums';
import { CardType, DEPOSIT_CONFIRMATION_TYPE } from '../../data-types/wallet/walletEnums';
import {
  DepositInfo,
  DepositInfoNotification,
  DepositTrackingInfo,
  MobilePaymentInitDialog,
  UserBonusWallet,
  UserPaymentMethodsData,
} from '../../data-types/wallet/walletInterfaces';
import { ResetState } from './stateTypes';

export type WalletActionType =
  | ResetState
  | SetUserBalance
  | SetDepositNotificationType
  | SetDepositAmount
  | SetDepositCardType
  | SetDepositNotification
  | SetDepositTrackingInfo
  | SetMobilePaymentInitDialog
  | SetUserPaymentMethodsData
  | SetUserPaymentMethodsDataLoading
  | SetAcknowledgeDepositOpen
  | SetUserTotalBalance
  | SetUserBonusWallet
  | SetWalletBalanceTypeDisplay;

export const SET_USER_BALANCE = 'SET_USER_BALANCE';
export const SET_DEPOSIT_CONFIRMATION_TYPE = 'SET_DEPOSIT_CONFIRMATION_TYPE';
export const SET_DEPOSIT_AMOUNT = 'SET_DEPOSIT_AMOUNT';
export const SET_DEPOSIT_CARD_TYPE = 'SET_DEPOSIT_CARD_TYPE';
export const SET_DEPOSIT_NOTIFICATION_CONTENT = 'SET_DEPOSIT_NOTIFICATION_CONTENT';
export const SET_DEPOSIT_TRACKING_INFO = 'SET_DEPOSIT_TRACKING_INFO';
export const SET_MOBILE_PAYMENT_INIT_DIALOG = 'SET_MOBILE_PAYMENT_INIT_DIALOG';
export const SET_USER_PAYMENT_METHODS_DATA = 'SET_USER_PAYMENT_METHODS_DATA';
export const SET_USER_PAYMENT_METHODS_DATA_LOADING = 'SET_USER_PAYMENT_METHODS_DATA_LOADING';
export const SET_ACKNOWLEDGE_DEPOSIT_OPEN = 'SET_ACKNOWLEDGE_DEPOSIT_OPEN';
export const SET_USER_TOTAL_BALANCE = 'SET_USER_TOTAL_BALANCE';
export const SET_USER_BONUS_WALLET = 'SET_USER_BONUS_WALLET';
export const SET_WALLET_BALANCE_TYPE_DISPLAY = 'SET_WALLET_BALANCE_TYPE_DISPLAY';

export interface WalletState {
  balance: number;
  totalBalance: number;
  bonusWallet: UserBonusWallet | undefined;
  depositInfo: DepositInfo;
  depositTrackingInfo: DepositTrackingInfo;
  mobilePaymentInitDialog: MobilePaymentInitDialog;
  userPaymentMethodsData: UserPaymentMethodsData;
  acknowledgeDepositOpen: boolean;
  walletBalanceTypeDisplay: BALANCE_SLIDE_STEP;
}

interface SetUserBalance {
  type: typeof SET_USER_BALANCE;
  meta: number;
}

interface SetDepositNotificationType {
  type: typeof SET_DEPOSIT_CONFIRMATION_TYPE;
  meta: DEPOSIT_CONFIRMATION_TYPE;
}

interface SetDepositTrackingInfo {
  type: typeof SET_DEPOSIT_TRACKING_INFO;
  meta: DepositTrackingInfo;
}

interface SetDepositAmount {
  type: typeof SET_DEPOSIT_AMOUNT;
  meta: number;
}

interface SetDepositCardType {
  type: typeof SET_DEPOSIT_CARD_TYPE;
  meta: CardType;
}

interface SetDepositNotification {
  type: typeof SET_DEPOSIT_NOTIFICATION_CONTENT;
  meta: DepositInfoNotification;
}

interface SetMobilePaymentInitDialog {
  type: typeof SET_MOBILE_PAYMENT_INIT_DIALOG;
  meta: MobilePaymentInitDialog;
}

interface SetUserPaymentMethodsData {
  type: typeof SET_USER_PAYMENT_METHODS_DATA;
  meta: UserPaymentMethodsData;
}

interface SetUserPaymentMethodsDataLoading {
  type: typeof SET_USER_PAYMENT_METHODS_DATA_LOADING;
  meta: boolean;
}

interface SetAcknowledgeDepositOpen {
  type: typeof SET_ACKNOWLEDGE_DEPOSIT_OPEN;
  meta: boolean;
}

interface SetUserTotalBalance {
  type: typeof SET_USER_TOTAL_BALANCE;
  meta: number;
}

interface SetUserBonusWallet {
  type: typeof SET_USER_BONUS_WALLET;
  meta: UserBonusWallet | undefined;
}

interface SetWalletBalanceTypeDisplay {
  type: typeof SET_WALLET_BALANCE_TYPE_DISPLAY;
  meta: BALANCE_SLIDE_STEP;
}
